import React from "react";
import { BecauseYouPlayedComponent } from "../../../../../components/because-you-played/because-you-played.component";
import { SwiperGamesListConfiguration } from "../../../../configurations/config-data-sections/arenas.configuration";
import { IArenaToGamesListAdapter } from "../../arenas/arena-to-games-list-adapter.interface";
import {ApiListBaseModel} from "../api-list-base.model";

export class BecauseYouPlayedPlayedListModel extends ApiListBaseModel {
    constructor(protected readonly listConfiguration: SwiperGamesListConfiguration, arena: IArenaToGamesListAdapter) {
        super(listConfiguration, arena);
        this.services.runningGame.listenForLastPlayedRealGame();
    }

    protected _shouldBeDisplayed(): boolean {
        return super._shouldBeDisplayed() &&
            this.gameTypes.length > 0;
    }

    protected _getTitleTranslationParams(): object | string | undefined {
        const lastPlayedGames = this.services.becauseYouPlayed.currentBecauseYouPlayedGames[0];
        if (lastPlayedGames) {
            return {
                gameName: lastPlayedGames.title
            }
        }

        return super._getTitleTranslationParams();
    }

    protected _getGameTypes(): number[] {
        return this.services.becauseYouPlayed.currentBecauseYouPlayedGames.map(gInfo => gInfo.gameType);
    }



    protected _renderList(listPosition: number): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return (
            <BecauseYouPlayedComponent key={this.listKey} viewModel={this} listPosition={listPosition} />
        );
    }
}
